// extracted by mini-css-extract-plugin
module.exports = {"landingFooter":"LandingFooter_landingFooter__2vqgU","footerContent":"LandingFooter_footerContent__2sJzI"};